import React from 'react';
import classNames from 'classnames/bind';
import styles from "../styles.pcss";
import { useStickyContainer } from "./useStickyContainer";
var cn = classNames.bind(styles);
export var StickyConnectContainer = function StickyConnectContainer(_ref) {
  var children = _ref.children;
  var _useStickyContainer = useStickyContainer(),
    shouldHide = _useStickyContainer.shouldHide,
    elementRef = _useStickyContainer.elementRef,
    startElementRef = _useStickyContainer.startElementRef,
    isInView = _useStickyContainer.isInView;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: cn('sticky-container', shouldHide && 'hide-sticky', isInView && 'fixed-sticky'),
    ref: startElementRef,
    "data-t-id": "Sticky-StickyConnectContainer"
  }, children), /*#__PURE__*/React.createElement("div", {
    ref: elementRef
  }));
};